import { jsx as _jsx } from "react/jsx-runtime";
import { Carousel, CarouselVariant, CarouselPaginationVariant, SliderNavVariant, LightBoxMainSlide, SliderNavColor, LightBoxMainPagination, } from '@as/cotopaxi';
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { useSlidesDisplayState } from '../../../../hooks/useSlidesDisplayState';
import { getVideoPlayerType } from '../../../../util/VideoUtil';
import { Video } from '../../../video/Video';
import { SlideInViewFrom } from '../ProductPreview';
export const LightBoxMainSlider = ({ activeSlideIndex, alt, mediaCollection, onActiveSlideIndexChange, onUpdateSlideInView, }) => {
    const [gallerySwiper, setGallerySwiper] = useState(null);
    const [activeSlide, setActiveSlide] = useState(activeSlideIndex);
    const [isSwiping, setIsSwiping] = useState(false);
    const slidesDisplayState = useSlidesDisplayState(activeSlideIndex, mediaCollection.length);
    const { t } = useTranslation(I18N_NAMESPACES.general);
    const lightBoxMainPaginationTranslations = {
        of: t(`${I18N_NAMESPACES.general}:of`),
    };
    const onGallerySlideChange = function () {
        const { activeIndex } = this;
        if (activeIndex === 0 || activeIndex !== activeSlideIndex) {
            onActiveSlideIndexChange(activeIndex);
            setActiveSlide(activeIndex);
            onUpdateSlideInView === null || onUpdateSlideInView === void 0 ? void 0 : onUpdateSlideInView(activeIndex, SlideInViewFrom.LIGHTBOX);
        }
    };
    const onGallerySlideChangeTransitionEnd = function () {
        setActiveSlide(this.activeIndex);
    };
    const renderSlide = useCallback((image, index, _alt) => (_jsx("div", { children: slidesDisplayState[index] && (_jsx(LightBoxMainSlide, { smallImagePath: image.sourceSet[ProductImageSizesPortraitEnum.detail], largeImagePath: image.sourceSet[ProductImageSizesPortraitEnum.zoom], videoComponent: image.video && (_jsx(Video, { iframe: true, url: image.video.productVideoDetail.url, playerType: getVideoPlayerType(image.video.productVideoDetail.url), stop: index !== activeSlideIndex })), alt: _alt, active: activeSlideIndex === index, isSwiping: isSwiping })) }, `image_${index}`)), [activeSlideIndex, isSwiping, slidesDisplayState]);
    const renderPagination = () => {
        if (!gallerySwiper) {
            return null;
        }
        return (_jsx(LightBoxMainPagination, { swiper: gallerySwiper, translations: lightBoxMainPaginationTranslations, activeSlide: activeSlide }));
    };
    const lightBoxMainSliderCarouselConfig = {
        variant: CarouselVariant.LIGHT_BOX_MAIN,
        arrowsConfig: {
            variant: SliderNavVariant.CIRCLE,
            color: SliderNavColor.BASE,
        },
        showPagination: true,
        paginationVariant: CarouselPaginationVariant.LIGHT_BOX,
        configurationOverrides: {
            initialSlide: activeSlideIndex,
            shouldSwiperUpdate: true,
            getSwiper: setGallerySwiper,
            spaceBetween: 0,
            centeredSlides: true,
            watchOverflow: true,
            renderPagination,
            on: {
                slideChange: onGallerySlideChange,
                slideChangeTransitionEnd: onGallerySlideChangeTransitionEnd,
                touchStart: () => {
                    setIsSwiping(true);
                },
                touchEnd: () => {
                    setIsSwiping(false);
                },
            },
        },
    };
    useEffect(() => {
        gallerySwiper === null || gallerySwiper === void 0 ? void 0 : gallerySwiper.slideTo(activeSlideIndex);
    }, [activeSlideIndex]);
    useEffect(() => {
        gallerySwiper === null || gallerySwiper === void 0 ? void 0 : gallerySwiper.update();
    }, [mediaCollection]);
    useEffect(() => {
        gallerySwiper === null || gallerySwiper === void 0 ? void 0 : gallerySwiper.update();
    }, [gallerySwiper]);
    return (_jsx(Carousel, Object.assign({}, lightBoxMainSliderCarouselConfig, { dataQA: "light_box_main_slider", children: mediaCollection.map((image, index) => renderSlide(image, index, alt)) })));
};
